import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}profile`;


export const addProfilePost = (product) => {
    const token = localStorage.getItem('token');

    return axios.post(API_URL, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const updateProfile = (id, product) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL}/${id}`, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const getProfileByIdUser = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/profile/by-user-profile`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}